import styled from 'styled-components'
import { Col as AntCol, List as AntList, Switch as AntSwitch } from 'antd'
import Text from 'antd/lib/typography/Text'
import AntTitle from 'antd/lib/typography/Title'

export const Col = styled(AntCol)`
  text-align: center;
`

export const ContainerButtonAdd = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`

export const Container = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
`

export const List = styled(AntList)`
  min-width: 60rem;
` as React.ComponentType as new <T>() => AntList<T>

export const TextInfo = styled(Text)`
  font-size: small;
`

export const Title = styled(AntTitle)`
  margin: 2rem 0;
`

export const SubTitle = styled(Text)`
  font-size: medium;
`

export const Switch = styled(AntSwitch)`
  margin-right: 0.5rem;
  width: 5rem;
`

export const SwitchDiv = styled.div`
  margin-top: 0.5rem;
`
